import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

function Header() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavigate = (path) => {
    setIsMenuOpen(false);
    navigate(path);
  };

  return (
    <header className="header">
      <nav className="navbar">
        <div className="container">
          <div className="logo" onClick={() => handleNavigate('/')} style={{ cursor: 'pointer' }}>
            <img src="/logo.png" alt="Durbhasi Gurukulam" className="logo-image" />
            <div className="logo-copy">
              <span className="logo-text">Durbhasi Gurukulam</span>
              <span className="logo-subtitle">LEARNING FROM EXPERTS</span>
            </div>
          </div>
          <button
            type="button"
            className="menu-toggle"
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen((open) => !open)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <ul className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
            <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
            <li><Link to="/courses" onClick={() => setIsMenuOpen(false)}>Courses</Link></li>
            <li><Link to="/support" onClick={() => setIsMenuOpen(false)}>Quick Support</Link></li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Header;
